import { Component, Inject, ViewChild } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { AlertMessageService } from "@bundle/component/alert-message/alert-message.service";
import { AppCOService } from "app/business/service/app/app-co.service";
import { AppMasterService } from "app/business/service/app/app-master.service";
import { DxDataGridComponent } from "devextreme-angular";

@Component({
  selector: "app-draft-co-popup",
  templateUrl: "./draft-co-popup.component.html",
  styleUrls: ["./draft-co-popup.component.scss"],
})
export class DraftCOPopupComponent {
  dataSource: any = [];
  @ViewChild(DxDataGridComponent, { static: false })
  dataGrid: DxDataGridComponent;
  data: any = {};
  previewPrint: any = {};
  updatePreviewPrint: any = {};
  request: any = {};
  isPack: string = "N";
  isNS: boolean;
  isCheck: boolean;
  isDraftOpened: boolean = false;
  listClick: boolean;
  respone: string;
  isChkOldPriority: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) data,
    public apiMasterService: AppMasterService,
    public dialogRef: MatDialogRef<DraftCOPopupComponent>,
    private appCOService: AppCOService,
    private alertMessageService: AlertMessageService
  ) {
    this.dataSource = data.data;
    this.data = data.data;
    this.listClick = data.listClick;
    this.previewPrint = this.data.previewPrint;
    this.isPack = data.data.isPack;
    this.respone = data.data.linkUrl;

    if (data.rqStatus == "10") {
      this.isChkOldPriority = true;
    } else {
      this.isChkOldPriority = false;
    }
  }

  onAction(e: any) {
    if (e.docHid != 0) {
      const data = {
        Hid: e.docHid,
        isCoPack: "Y",
      };
      this.appCOService.getPreviewCOPack(data).then((res: any) => {
        if (res === "error") {
          return;
        } else {
          this.isDraftOpened = true;
          window.open(res.linkUrl, "_blank");
        }
      });
    } else {
      this.request = this.previewPrint;
      this.updatePreviewPrint = this.request.coPack;
      this.request.coPack = [e];
      const data = {
        previewCO: this.request,
        isCoPack: "Y",
      };
      this.appCOService.getPreviewCOPack(data).then((res: any) => {
        if (res === "error") {
          return;
        } else {
          this.isDraftOpened = true;
          window.open(res.linkUrl, "_blank");
        }
      });
      this.request.coPack = this.updatePreviewPrint;
    }
  }
  preview() {
    this.isDraftOpened = true;
    window.open(this.respone, "_blank");
  }
  save() {
    if (this.isDraftOpened) {
      this.dialogRef.close();
    } else if (this.isChkOldPriority) {
      this.dialogRef.close();
    } else {
      this.alertMessageService.open({
        message: "กรุณาตรวจสอบเอกสาร Draft ก่อนส่งตรวจ",
        title: "",
      });
    }
  }
  cancel() {
    this.dialogRef.close(false);
  }
}
